var render = function render(){var _vm=this,_c=_vm._self._c;return _c('comments',{class:{ is_vertical_window: _vm.is_vertical_window },attrs:{"dataUid":_vm.dataUid,"small":_vm.is_vertical_window,"id":"mobile-comments","commentsUnread":(_vm.commentsUnread = 0),"presence_members":_vm.presence_members,"ticket":_vm.ticket,"channelName":_vm.channelName,"service":_vm.apiService}})
}
var staticRenderFns = []

export { render, staticRenderFns }